<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        查看评估项目
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          v-if="xmInfo.xmzt === 'DSC'"
          v-permission-element="'pgxm_scbg'"
          btn-text="生成报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="handleScbg()"
        />
        <k-button
          v-if="xmInfo.xmzt === 'DSC'"
          v-permission-element="'pgxm_scbg_ls'"
          btn-text="生成临时报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="handleSclsbg()"
        />
        <k-button
          v-if="lsbgFileId &&xmInfo.xmzt === 'DSC'"
          btn-text="查看临时报告"
          :auth-type="false"
          type="primary"
          plain
          icon="kestrel-icon ki-file-pdf"
          :disabled="xmInfo.previewPdf"
          @click="(e)=>$utils.previewPdf(e,lsbgFileId,xmInfo)"
        >
          <i
            v-show="xmInfo.previewPdf"
            class="el-icon-loading"
          />
        </k-button>
        <!-- 生成报告后待签章，可重新评估 -->
        <k-button
          v-if="xmInfo.xmzt === 'DQZ' && xmInfo.tsbz !== 'Y'"
          v-permission-element="'pgxm_cxpg'"
          btn-text="重新评估"
          :auth-type="true"
          type="success"
          plain
          icon="el-icon-notebook-2"
          @click="handleCxpg()"
        />
        <!-- <k-button
          btn-text="导出"
:auth-type="false"
          v-if="xmInfo.xmzt === 'DQZ'"
          v-permission-element="'pgxm_qz'"
          type="success"
          plain
          icon="kestrel-icon ki-qrcode"
          @click="handleQz()"
        >
          签章
        </k-button> -->
        <!-- 签章后报告修改需申请，记录修改原因 -->
        <k-button
          v-if="xmInfo.xmzt === 'DGZ' || xmInfo.xmzt === 'YGZ' || xmInfo.xmzt === 'YQZ'"
          v-permission-element="'pgxm_sqxg'"
          btn-text="申请修改"
          :auth-type="true"
          type="primary"
          plain
          icon="el-icon-edit"
          @click="handleDialog('sqxg',{id: xmId})"
        />
        <k-button
          v-if="xmInfo.xmzt === 'DGZ'"
          v-permission-element="'pgxm_gz'"
          btn-text="加盖公章"
          :auth-type="true"
          type="success"
          plain
          icon="kestrel-icon ki-qrcode"
          @click="handleJggz()"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：仅tabs为主内容 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="xmInfo"
        >
          <view-xminfo
            ref="xminfo"
            @updateXminfo="handleXminfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="实施规划"
          name="action"
        >
          <action-info
            ref="actionInfo"
            type="view"
            :xm-info="xmInfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="评估明细"
          name="pgmx"
        >
          <pgmx-list />
        </el-tab-pane>

      <!-- 页面主内容：仅tabs为主内容 End -->
      </el-tabs>
    </div>

    <sqxg-dialog
      v-if="showDialogName === 'sqxg'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleSqxg()"
    />
  </div>
</template>

<script>
import viewXminfo from './viewXminfo.vue';
import pgmxList from './pgmxList.vue';
import actionInfo from './actionInfo.vue';
import SqxgDialog from './SqxgDialog.vue';
import { pgxmManageService } from '../pgxm.service';
export default {
  name: 'EditPgxm',
  components: {
    viewXminfo,
    pgmxList,
    actionInfo,
    SqxgDialog
  },
  data () {
    return {
      loading: false, // 页面loading状态
      activeName: 'xmInfo',
      xmId: null,
      xmInfo: {}, // 维保项目信息
      lsbgFileId: null, // 临时报告文件id

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 end */
    };
  },
  methods: {
    /**
     * @description: 维保项目信息处理
     * @return {*}
     * @param {*} data
     */
    handleXminfo (data) {
      this.xmInfo = data;
    },
    /**
     * @description: 生成临时报告
     * @return {*}
     */
    handleSclsbg () {
      const _this = this;
      _this.loading = true;
      pgxmManageService.sclsbg(_this.xmId)
        .then(rsp => {
          this.lsbgFileId = rsp.data.data;
        })
        .catch(err => {
          _this.$alert('生成报告失败！', '提示', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {
            }
          });
          console.error('生成报告失败！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 生成报告
     * @return {*}
     */
    handleScbg () {
      const _this = this;
      _this.$confirm('是否确认生成报告？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          _this.loading = true;
          pgxmManageService.scbg(_this.xmId)
            .then(rsp => {
              _this.$alert('报告生成成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$refs.xminfo.init();
            })
            .catch(err => {
              console.error('报告生成失败！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        })
        .catch(() => {});
    },
    /**
     * @description: 签章
     * @return {*}
     */
    handleQz () {
      const _this = this;
      _this.$confirm('是否确认签章？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgxmManageService.qz(_this.xmId)
          .then(rsp => {
            _this.$alert('签章成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {

              }
            });
            _this.$refs.xminfo.init();
          })
          .catch(err => {
            console.error('签章失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 加盖公章
     * @return {*}
     */
    handleJggz () {
      const _this = this;
      _this.$confirm('是否确认加盖公章？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgxmManageService.jggz(_this.xmId)
          .then(rsp => {
            _this.$alert('加盖公章成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.$refs.xminfo.init();
          })
          .catch(err => {
            console.error('加盖公章失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 重新评估
     * @return {*}
     */
    handleCxpg () {
      const _this = this;
      _this.$confirm('是否确认重新评估？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgxmManageService.cxpg(_this.xmId)
          .then(rsp => {
            _this.$alert('设置成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.$refs.xminfo.init();
            _this.closeNavTabAndTo({ name: 'pgxmEdit', params: { id: _this.xmId } }, true);
          })
          .catch(err => {
            console.error('设置失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 签章后报告修改需申请，记录修改原因
     * @return {*}
     */
    handleSqxg () {
      this.closeNavTabAndTo({ name: 'pgxmEdit', params: { id: this.xmId } }, true);
    },
    /**
     * @description: 跳转窗口
     * @author: cgh
     */
    handleDialog (_name, params) {
      this.showDialogName = _name;
      this.dialogParams = params;
    }
  },
  created () {
    this.xmId = this.$route.params.id;
    if (this.$route.params.showType) {
      this.activeName = this.$route.params.showType;
    }
  },
  activated () {
    if (this.$route.params.showType) {
      this.activeName = this.$route.params.showType;
    }
  }
};
</script>

<style>

</style>
